import createElement from '../../logical-components/createElement';
import '../scss/button.scss';
var buildButton = function (_a) {
    var label = _a.label, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, onClick = _a.onClick;
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-wr-bw' },
    ]);
    wrapper.innerHTML = "\n        <button class='msnq-".concat(variant, "'> ").concat(label, " </button>\n    ");
    // Apply event listener
    wrapper.querySelector('button').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    });
    return wrapper;
};
export default buildButton;
